<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                <section :class="{'pb-6': phoneOnly, 'pb-15': pcOnly}">
                    <v-container>
                        <v-img :src="`/img/${pcOnly ? 'header-pc' : 'header'}.png`" max-height="700px" contain></v-img>
                    </v-container>
                </section>

                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div class="d-md-flex justify-space-between align-center mb-8 mb-lg-15">
                            <h1 class="strong-text--text">
                                <v-icon :size="pcOnly ? 45 : 36" color="strong-text">mdi-play-box-multiple-outline</v-icon>
                                المحاضرات
                            </h1>
                            <template v-if="pcOnly">
                                <div class="flex-grow-1 mx-12">
                                    <v-divider></v-divider>
                                </div>
                                <div>
                                    <v-btn outlined color="primary" :to="{name: 'courses'}">
                                        <span>الكل</span>
                                        <v-icon right>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </div>
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />

                            <div class="my-4 mx-6">
                                <v-btn block outlined color="primary" :to="{name: 'courses'}">
                                    <span>عرض الكل</span>
                                    <v-icon right>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                        </v-list>
                    </v-container>
                </section>

                <section class="py-12 py-md-15" style="background-color: #0a0425;">
                    <v-container class="px-0">
                        <h1 class="text-center white--text mb-6">ليه MAG Academy أفضل اختيار ليك؟</h1>
                        <div class="d-flex flex-row align-center justify-space-around justify-md-center flex-wrap white--text">
                            <div v-for="i in 6" :key="i" class="pa-2 pa-md-5 pa-lg-8"> 
                                <img :src="`/img/home-items/${i}.png`" :style="`height: ${pcOnly ? '160' : '120'}px`" class="scale-animation" />
                            </div>
                        </div>
                    </v-container>

                </section>

                <section :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container style="position: relative;">
                        <h1 class="text-center primary--text mb-6" style="font-size: 3rem!important;">#عمدة الكيمياء</h1>
                        <template v-if="pcOnly">
                            <img src="/img/vector-icon2.png" style="position: absolute; top: 0%; right: 0px;" class="rotate-animation" />
                            <img src="/img/vector-icon1.png" style="position: absolute; top: 0; left: 0px; width: 200px;" class="flip-animation" />
                        </template>
                        <img v-else src="/img/vector-icon2.png" style="position: absolute; bottom: 0%; right: 0px; width: 110px;" class="flip-animation" />
                    </v-container>

                </section>
                <slot name="footer" />
            </div>
        </transition>


        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        AppWelcomeDialog
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
section{
    h1{
        font-size: 2.4rem!important;
        line-height: 1.3;
        font-weight: 500;

        @media(max-width: 960px){
            font-size: 1.9rem!important;
            text-align: center;
        }
    }
}

.scale-animation{
	backface-visibility: visible !important;
	animation: scale-animation 2s ease infinite;
}
.rotate-animation {
	backface-visibility: visible !important;
	animation: rotate-animation 2s ease infinite;
    animation-delay: 1s;
}
.flip-animation {
	backface-visibility: visible !important;
	animation: flip-animation 2s ease infinite;
}
@keyframes flip-animation {
	0% {
		transform: perspective(400px) rotateY(0);
		animation-timing-function: ease-out;
	}
	40% {
		transform: perspective(400px) translateZ(150px) rotateY(170deg);
		animation-timing-function: ease-out;
	}
	50% {
		transform: perspective(400px) translateZ(150px) rotateY(190deg) scale(1);
		animation-timing-function: ease-in;
	}
	80% {
		transform: perspective(400px) rotateY(360deg) scale(.85);
		animation-timing-function: ease-in;
	}
	100% {
		transform: perspective(400px) scale(1);
		animation-timing-function: ease-in;
	}
}

@keyframes rotate-animation {
	0% {
		transform: rotate(0deg) scale(1);
		animation-timing-function: ease-out;
	}
	20% {
		transform: rotate(8deg) scale(0.95);
		animation-timing-function: ease-out;
	}
	50% {
		transform: rotate(0deg) scale(1);
		animation-timing-function: ease-in;
	}
	80% {
		transform: rotate(-8deg) scale(0.95);
		animation-timing-function: ease-in;
	}
	100% {
		transform: rotate(0deg) scale(1);
		animation-timing-function: ease-in;
	}
}

@keyframes scale-animation {
	0% {
		transform: scale(0.9);
		animation-timing-function: ease-out;
	}
	20%, 50%, 80% {
		transform: scale(1);
		animation-timing-function: ease-in;
	}
	100% {
		transform: scale(0.9);
		animation-timing-function: ease-in;
	}
}
</style>